import { render, staticRenderFns } from "./LogMessage.vue?vue&type=template&id=58dd4268&scoped=true&"
import script from "./LogMessage.vue?vue&type=script&lang=js&"
export * from "./LogMessage.vue?vue&type=script&lang=js&"
import style0 from "./LogMessage.vue?vue&type=style&index=0&id=58dd4268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd4268",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
